import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchInsertCompany } from "./companyAPI";
import swal from 'sweetalert';
export interface InsertCompanyState {
  insertCompany: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: InsertCompanyState = {
    insertCompany: [],
  status: "idle",
};

export const GetInsertCompany = createAsyncThunk(
  "InsertCompany/fetchInsertCompany",
  async (data:any) => {
    const response = await fetchInsertCompany(data);
    return response;
  }
);

export const InsertCompanySlice = createSlice({
  name: "InsertCompany",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetInsertCompany.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetInsertCompany.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetInsertCompany.fulfilled, (state, action) => {
        state.status = "idle";
        state.insertCompany = action.payload;
        swal("Record saved success!",  "success");
      });
  },
});

export const {} = InsertCompanySlice.actions;

export const selectInsertCompany = (state: RootState) => {
  return state.InsertCompany.insertCompany;
};

export default InsertCompanySlice.reducer;
